export enum QuestionnaireModule {
	MEDDIBABY = 'MEDDIBABY',
	DIABETES = 'DIABETES',
	THERAPIST = 'THERAPIST',
	PALLIATIVE = 'PALLIATIVE',
	ONCOLOGY = 'ONCOLOGY',
	KDAR = 'KDAR',
	OBESITOLOGY = 'OBESITY',
}
